import { CommonNS } from "../../../../../../Common/CommonNS.js";
export const initDOM = (self) => {
  const canvas_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "svg"
  );
  canvas_el.style.backgroundColor = "#F8F9FA";
  canvas_el.setAttributeNS(null, "x", "0");
  canvas_el.setAttributeNS(null, "y", "0");
  canvas_el.setAttributeNS(null, "width", "0");
  canvas_el.setAttributeNS(null, "height", "0");
  canvas_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "canvas";
  self._canvas_el = canvas_el;
  const dummy_g_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  dummy_g_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "dummy";
  canvas_el.appendChild(dummy_g_el);
  self._dummy_g_el = dummy_g_el;
  const layers_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "svg"
  );
  layers_el.setAttributeNS(null, "x", "0");
  layers_el.setAttributeNS(null, "y", "0");
  layers_el.setAttributeNS(null, "width", "0");
  layers_el.setAttributeNS(null, "height", "0");
  layers_el.setAttributeNS(null, "preserveAspectRatio", "xMidYMid meet");
  layers_el.setAttributeNS(null, "viewBox", "0 0 0 0");
  layers_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "layers";
  canvas_el.appendChild(layers_el);
  self._layers_el = layers_el;
  const target_image_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  target_image_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "target-image-layer";
  layers_el.appendChild(target_image_layer_el);
  self._target_image_layer_el = target_image_layer_el;
  const cutting_line_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  cutting_line_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "cutting-line-layer";
  layers_el.appendChild(cutting_line_layer_el);
  self._cutting_line_layer_el = cutting_line_layer_el;
  const path_editor_layer_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  path_editor_layer_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "path-editor-layer";
  layers_el.appendChild(path_editor_layer_el);
  self._path_editor_layer_el = path_editor_layer_el;
  const target_image_outer_wrapper_g_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  target_image_outer_wrapper_g_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "target-image-outer-wrapper";
  target_image_outer_wrapper_g_el.setAttributeNS(
    null,
    "clip-path",
    `url(#${self._outer_cutting_line_clip_path_id})`
  );
  target_image_layer_el.appendChild(target_image_outer_wrapper_g_el);
  self._target_image_outer_wrapper_g_el = target_image_outer_wrapper_g_el;
  const target_image_inner_wrapper_g_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  target_image_inner_wrapper_g_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "target-image-inner-wrapper";
  target_image_inner_wrapper_g_el.setAttributeNS(
    null,
    "clip-path",
    `url(#${self._inner_cutting_line_clip_path_id})`
  );
  target_image_outer_wrapper_g_el.appendChild(target_image_inner_wrapper_g_el);
  self._target_image_inner_wrapper_g_el = target_image_inner_wrapper_g_el;
  const target_image_dummy_g_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  target_image_dummy_g_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "target-image-dummy-g";
  self._target_image_dummy_g_el = target_image_dummy_g_el;
  const outer_cutting_line_clip_path_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "path"
  );
  outer_cutting_line_clip_path_el.setAttributeNS(
    null,
    "d",
    self._outer_cutting_line_path_data
  );
  outer_cutting_line_clip_path_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "outer-cutting-line-clip-path";
  (() => {
    const outer_clip_path_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "clipPath"
    );
    outer_clip_path_el.setAttributeNS(
      null,
      "id",
      self._outer_cutting_line_clip_path_id
    );
    outer_clip_path_el.appendChild(outer_cutting_line_clip_path_el);
    const defs_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "defs"
    );
    defs_el.appendChild(outer_clip_path_el);
    cutting_line_layer_el.appendChild(defs_el);
  })();
  self._outer_cutting_line_clip_path_el = outer_cutting_line_clip_path_el;
  const inner_cutting_line_clip_path_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "path"
  );
  inner_cutting_line_clip_path_el.setAttributeNS(
    null,
    "d",
    self._inner_cutting_line_path_data
  );
  inner_cutting_line_clip_path_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "inner-cutting-line-clip-path";
  (() => {
    const inner_clip_path_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "clipPath"
    );
    inner_clip_path_el.setAttributeNS(
      null,
      "id",
      self._inner_cutting_line_clip_path_id
    );
    inner_clip_path_el.appendChild(inner_cutting_line_clip_path_el);
    const defs_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "defs"
    );
    defs_el.appendChild(inner_clip_path_el);
    cutting_line_layer_el.appendChild(defs_el);
  })();
  self._inner_cutting_line_clip_path_el = inner_cutting_line_clip_path_el;
  const outer_cutting_line_display_path_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "path"
  );
  outer_cutting_line_display_path_el.setAttributeNS(
    null,
    "d",
    self._outer_cutting_line_path_data
  );
  outer_cutting_line_display_path_el.setAttributeNS(null, "fill", "none");
  outer_cutting_line_display_path_el.setAttributeNS(null, "stroke", "#FF00FF");
  outer_cutting_line_display_path_el.setAttributeNS(null, "stroke-width", "1");
  outer_cutting_line_display_path_el.setAttributeNS(
    null,
    "vector-effect",
    "non-scaling-stroke"
  );
  outer_cutting_line_display_path_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "outer-cutting-line-display-path";
  cutting_line_layer_el.appendChild(outer_cutting_line_display_path_el);
  self._outer_cutting_line_display_path_el = outer_cutting_line_display_path_el;
  const path_editor_line_container_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  path_editor_line_container_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "path-editor-line-container";
  path_editor_layer_el.appendChild(path_editor_line_container_el);
  self._path_editor_line_container_el = path_editor_line_container_el;
  const path_editor_point_container_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  path_editor_point_container_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "path-editor-point-container";
  path_editor_layer_el.appendChild(path_editor_point_container_el);
  self._path_editor_point_container_el = path_editor_point_container_el;
};
